/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import styled from "@emotion/styled";
import { Box, Button, TextField } from "@mui/material";

export const HeaderContainer = styled.section`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
`;

export const ModalTitle = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  margin: 0;
  color: #303030;
`;

export const ModalBody = styled.section`
  padding: 20px;
`;

export const MainText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;

  color: #707070;
`;

export const CloseButton = styled(Button)`
  width: 100px;
  height: 50px;
  text-transform: uppercase;
  background-color: #f5f5f5;
  color: #303030;
  margin: 0;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ModalFooter = styled.section`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
`;

export const CloseIconBox = styled.div`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
`;
export const ActionModalFooter = styled.section`
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 20px;
`;

export const StyledDiscountCardContainer = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  padding: "32px",
  minWidth: 400,
  borderRadius: "4px",
});

export const StyledConfirmButton = styled(Button)(({ modalAction }) => ({
  background: modalAction === "assign" ? "#2b4fb9" : "#DB3B11",
  "&:hover": {
    backgroundColor:
      modalAction === "assign" ? "#2b4fb9" : "#DB3B11 !important",
  },
  textTransform: "none",
}));

export const StyledButton = styled(Button)({
  fontSize: "0.875rem",
  textTransform: "none",
  fontWeight: 600,
  border: "1px solid rgba(0,0,0,.12)",
  background: "white",
  "&:hover": {
    backgroundColor: "white",
  },
  padding: "6px 16px 6px 16px",
});

export const StyledTitle = styled('p')({
  fontWeight: '600',
  fontSize: "1.4rem",
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '25px',
  },
  '& .MuiInputBase-root':{
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: "white",
    marginRight: '18px',
  },
})
